# Ejercicio & Juego: Actividad para Cada Mascota

El movimiento mantiene las articulaciones sanas, ayuda al control de peso y reduce el estrés. La constancia importa más que la intensidad, así que crea hábitos que tu mascota disfrute.

<ArticleImage
  src="https://images.unsplash.com/photo-1650633907713-e0a619c1a69a?q=80&w=1633&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
  alt="Persona caminando al aire libre"
  caption="Los paseos diarios son una base simple y efectiva para la mayoría de las mascotas."
/>

---

<Section emoji="🚶" title="El Movimiento Diario Importa">

<Tip label="Paseos de olfato" text="Permite tiempo para oler y explorar — es enriquecimiento mental además de ejercicio." />
<Tip label="Opciones en casa" text="Buscar la pelota en el pasillo, tirar de la cuerda o juegos cortos de entrenamiento funcionan bien en días de lluvia." />
<Tip label="Constancia" text="Intenta mantener el mismo horario cada día para ayudar a la mascota a asentarse en la rutina." />

</Section>

<ArticleImage
  src="https://images.unsplash.com/photo-1629898452932-07074d3f9944?q=80&w=1074&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
  alt="Equipo de ejercicio sobre una colchoneta"
  caption="El trabajo de fuerza y equilibrio mantiene a las mascotas ágiles y seguras."
/>

<Section emoji="🧠" title="Juego que Estimula la Mente">

<Tip label="Comederos rompecabezas" text="Los juguetes de alimentación lenta añaden trabajo mental y reducen el aburrimiento." />
<Tip label="Entrenos cortos" text="Sesiones de cinco minutos de sentado, quieto o tocar el blanco mejoran el enfoque y el control." />
<Tip label="Rotar juguetes" text="Cambia los juguetes cada semana para mantener el interés sin comprar más." />

</Section>

<ArticleImage
  src="/images/guide/exercise-goat.jpg"
  alt="Piscina para nadar"
  caption="Las actividades de bajo impacto son ideales para mayores y recuperación."
/>

<Section emoji="🧬" title="Edad, Raza & Salud">

<Tip label="Cachorros" text="El juego corto y frecuente es mejor que sesiones largas e intensas." />
<Tip label="Mayores" text="Paseos suaves y superficies blandas reducen la carga en las articulaciones." />
<Tip label="Razas braquicéfalas" text="Evita el calor y el esfuerzo fuerte; vigila la respiración ruidosa." />

</Section>

<Section emoji="🌦️" title="Seguridad & Clima">

<Tip label="Hidratación" text="Lleva agua y toma descansos en días calurosos." />
<Tip label="Pavimento caliente" text="Si está demasiado caliente para tu mano, está demasiado caliente para las patas." />
<Tip label="Recuperación" text="Los días de descanso son parte del plan — la energía necesita tiempo para reconstruirse." />

</Section>

<Disclaimer title="⚠️ Recordatorio Amigable">
Esta guía es educativa y no sustituye la orientación veterinaria. Si tu mascota cojea, tose o parece inusualmente cansada después de la actividad, consulta con tu veterinario.
</Disclaimer>
